module.exports = __webpack_public_path__ + "static/media/award-csr.6c8f1662.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/home/img/award-csr.svg
// module id = 564
// module chunks = 0